import { render, staticRenderFns } from "./PermisosLista.vue?vue&type=template&id=a46c24f0&scoped=true&"
import script from "./PermisosLista.vue?vue&type=script&lang=js&"
export * from "./PermisosLista.vue?vue&type=script&lang=js&"
import style0 from "./PermisosLista.vue?vue&type=style&index=0&id=a46c24f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46c24f0",
  null
  
)

export default component.exports